/*
 * localStorage keys shared by the client audience hooks and the server-side
 * pre-paint script. Site-scoped, matching the SDK's own `customer_type_<siteId>`.
 */
export const customerTypeKey = (siteId) => `customer_type_${siteId}`
export const groupsKey = (siteId) => `gdi_groups_${siteId}`
export const abKey = (siteId) => `gdi_ab_${siteId}`
